const loadPolyfills = async () => {
  // To improve bundle size in the future in here we could dynamically load polyfills
  // after feature detection. For now we already only include the polyfills for the
  // features we actually use but we also load these for the browsers that don't actually need them.
};

export default loadPolyfills;
